<div class="mt-5 pt-4 d-flex flex-column justify-content-center align-items-center color-main">
  <h2 class="mb-4">¿HABLAMOS?</h2>
  <componenteBoton class="mt-2"
    texto="CONTACTA CONMIGO" 
    colorBoton="#410753"
    colorHover="#fff"
    url="contacto"/>
</div>
<div class="mt-5 pt-5"></div>
